import * as React from "react";
import { useAuth } from "../../../App";
import { OrthodonticReferralProvningskonsultApi } from "../../../api/OrthodonticReferralProvningskonsultApi";
import { IOrthodonticReferral } from "../../../models/IOrthodonticReferral";
import { IPage } from "../../../models/IPage";
import { IPagination } from "soprasteria-ui-library/dist/models/IPagination";
import { setMessage } from "../../../helpers/MessageHelper";
import { PaginationNavigation, SpinnerWrapper, AlertMessage, AlertType } from "soprasteria-ui-library";
import { OrthodonticReferralProvningskonsultSummaryTable } from "./OrthodonticReferralProvningskonsultSummaryTable";
import { useHistory } from "react-router";

export const OrthodonticReferralProvningskonsultSummary: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new OrthodonticReferralProvningskonsultApi(auth);
    const abortController = new AbortController();
    const history = useHistory();

    const [isFetchingOrthodonticReferrals, setIsFetchingOrthodonticReferrals] = React.useState<boolean>(false);
    const [orthodonticReferrals, setOrthodonticReferrals] = React.useState<IOrthodonticReferral[]>([]);

    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const [pagingParameters, setPagingParameters] = React.useState<IPage>({ pageNumber: 1, pageSize: 20 });
    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    React.useEffect(() => {
        if (history.location.state !== undefined && history.location.state !== null) {
            const newMessage = setMessage(history.location.state as string, successMessage);
            setSuccessMessage(newMessage);
        }

        getOrthodonticReferrals(pagingParameters);

        return () => {
            abortController.abort();
        }
    }, [, pagingParameters]);

    const getOrthodonticReferrals = (params: IPage) => {
        setIsFetchingOrthodonticReferrals(true);
        api.getOrthodonticReferral(params, (response) => {
            setOrthodonticReferrals(response.data);
            setPaginationHeader(response.paginationHeader);
        }, (message) => {
            const newMessage = setMessage(message, errorMessage)
            setErrorMessage(newMessage);
        }, () => {
            setIsFetchingOrthodonticReferrals(false);
        });
    }

    const onPageChange = (pageNumber: number) => {
        setPagingParameters(prevState => {
            return { ...prevState, pageNumber: pageNumber }
        });
    }

    return (
        <section className="card">
            <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
            <AlertMessage alertType={AlertType.success} duration={3000}>{successMessage}</AlertMessage>
            <SpinnerWrapper isLoading={isFetchingOrthodonticReferrals}>
                <div className="card-header">
                    <h1>Ortodontiremisser för bedömning</h1>
                </div>
                <div className="card-body">
                    <OrthodonticReferralProvningskonsultSummaryTable orthodonticReferrals={orthodonticReferrals}/>
                    <PaginationNavigation
                        ariaLabel="pagination selector"
                        pagination={paginationHeader}
                        pageNeighbours={2}
                        showCount={true}
                        selectedPage={onPageChange} />
                </div>
            </SpinnerWrapper>
        </section>
    )
}